import { Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { fetchCities } from '../../api/cityApi';
import { useTranslation } from 'react-i18next';
import { City } from '../../types/city';

const CitySelect: React.FC<{ value?: string; onChange?: (value: string) => void }> = ({ value, onChange }) => {
    const [cities, setCities] = useState<City[]>([]);
    const { t, i18n } = useTranslation(); // 🟢 Added t

    useEffect(() => {
        fetchCities().then(setCities);
    }, []);

    const getCityName = (city: City) => {
        switch (i18n.language) {
            case 'ckb': return city.name_ku;
            case 'ar': return city.name_ar;
            default: return city.name_eng;
        }
    };

    return (
        <Select value={value} onChange={onChange} placeholder={t('form.selectCity')}>
            {cities.map(city => (
                <Select.Option key={city.id} value={city.id}>
                    {getCityName(city)}
                </Select.Option>
            ))}
        </Select>
    );
};

export default CitySelect;
